// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".footer-info[data-v-e5bb27f6] {\n  font-size: 0.62rem !important;\n  font-weight: 400;\n  letter-spacing: 0.1666666667em !important;\n  line-height: 1rem;\n  text-transform: uppercase;\n}", ""]);
// Exports
module.exports = exports;
